import { render, staticRenderFns } from "./AuthAppBrandingTab.vue?vue&type=template&id=426fcf09&scoped=true"
import script from "./AuthAppBrandingTab.vue?vue&type=script&lang=js"
export * from "./AuthAppBrandingTab.vue?vue&type=script&lang=js"
import style0 from "./AuthAppBrandingTab.vue?vue&type=style&index=0&id=426fcf09&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426fcf09",
  null
  
)

export default component.exports